module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/place-holder-image-9ae78a5448270adac151ac1d81bd67b4.jpg";